import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Table } from 'virtues-bootstrap';

import s from './styles.module.scss';

const DataTable = ({ className, ...rest }) => (
  <Table className={cx(s.dataTable, className)} size="sm" striped {...rest} />
);

DataTable.propTypes = {
  className: PropTypes.string,
};

DataTable.defaultProps = {
  className: null,
};

export default DataTable;
